export type EndCompanyOrganisationCompany = {
  is_marketplace?: boolean
  represents_organisation_id?: null | number
}

/**
 * The End Company Organisation: the Organisation that supplies a Load's eligible End Customer or
 * End Carrier Companies. That is the Represented Organisation of a 3PL Broker, otherwise the Load
 * Organisation. Like the API, a marketplace company is a 3PL Broker whatever its type.
 */
export const getEndCompanyOrganisationId = (
  company: EndCompanyOrganisationCompany | null | undefined,
  loadOrganisationId: number | undefined,
) => {
  if (company?.is_marketplace !== true) return loadOrganisationId

  return company.represents_organisation_id ?? loadOrganisationId
}

/**
 * Whether the company is a 3PL Broker with a Represented Organisation. Such a broker passes payment
 * terms through from the Load's End Customer or End Carrier instead of using its own.
 */
export const representsOrganisation = (company: EndCompanyOrganisationCompany | null | undefined) =>
  company?.is_marketplace === true && company.represents_organisation_id != null
